__turbopack_context__.v({
  "burst": "_GuD4a_burst",
  "pop": "_GuD4a_pop",
});
